import { Button, Form } from "rsuite";
import { useState, useEffect, useCallback } from "react";
import {
  UserAddFormType,
  UserAddFormSchema,
  UserAddDefaultValues,
} from "../../models/forms/usersAddForm";
import { UsersEditForm } from "./EditUsersForm.component";
import { ApiUser } from "../../core/apis/user";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiSchemaUser } from "../../models/api/apiSchemaUser";
import { AppRoutesUI } from "../../config/appRoutes";
import { showSuccessToast, showErrorToast } from "../generic/toast.component";

export const EditUsers = () => {
  const location = useLocation();
  const [data, setData] = useState<ApiSchemaUser>();
  const [formValue, setFormValue] =
    useState<UserAddFormType>(UserAddDefaultValues);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [userSubscriptionType, setUserSubscriptionType] = useState("");
  const [isPaid, setIsPaid] = useState<boolean>(false);

  const handleChange = useCallback(
    (data: any, _: any) =>
      setFormValue((prevFormData) => ({ ...prevFormData, ...data })),
    []
  );

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    ApiUser.getUserDataById(location.state as string).then((res) => {
      setData(res.Data);
      if (data?.IsPaid === true) setUserSubscriptionType("paid");
      else setUserSubscriptionType("trial");
      setFormValue({
        userId: res.Data?.Id,
        email: res.Data?.Email,
        userName: res.Data?.UserName,
        firstName: res.Data?.FirstName,
        lastName: res.Data?.LastName,
        companyName: res.Data?.CompanyName,
        typeOfCompany: res.Data?.TypeOfCompany,
        wtaSubType: res.Data?.WTAUserType,
        tpaSubType: res.Data?.TPAUserType,
        paidFeatureSubscriptionType: res.Data?.PaidFeatureSubscriptionType,
        userType: res.Data?.IsPaid === true ? "paid" : "trial",
        registrationDate: res.Data?.CreateDate
          ? new Date(res.Data?.CreateDate)
          : new Date(),
        expiryDate: res.Data?.ExpireDate
          ? new Date(res.Data?.ExpireDate)
          : new Date(),
        phoneNumber: res.Data?.PhoneNumber,
        expireDayCount: parseInt(res.Data?.ExpirePeriod ?? "0"),
      });
    });
  };

  const expiredDateChange = (
    expiredDate: Date,
    expireCount: number | string
  ) => {
    var newFormData = { ...formValue };
    newFormData.expiryDate = expiredDate;
    newFormData.expireDayCount = expireCount;
    setFormValue(newFormData);
  };
  const handleSave = async (checked: boolean) => {
    const isValidate = () => {
      const isRequiredFieldValidate =
        formValue.email &&
        formValue.userName &&
        formValue.firstName &&
        formValue.lastName &&
        formValue.wtaSubType &&
        formValue.tpaSubType &&
        formValue.userType;
      if (isRequiredFieldValidate) {
        return true;
      } else {
        return false;
      }
    };
    if (isValidate()) {
      const userId = location.state as string;
      if (formValue.userType === "trial") {
        setIsPaid(false);
      } else setIsPaid(true);
      setIsLoading(true);
      try {
        await ApiUser.updateUser(
          userId,
          formValue.firstName || "",
          formValue.lastName || "",
          formValue.companyName || "",
          formValue.typeOfCompany || "",
          formValue.wtaSubType || "",
          formValue.tpaSubType || "",
          formValue.paidFeatureSubscriptionType || "",
          formValue.jobTitle || "",
          formValue.phoneNumber || "",
          formValue.userType === "trial" ? false : true,
          formValue.registrationDate || new Date(),
          formValue.expiryDate || new Date(),
          formValue.userType === "paid"
            ? "12"
            : formValue.expireDayCount?.toString() || "1"
        );
        showSuccessToast("User Updated Successfully");
      } catch (error: any) {
        showErrorToast(error.response?.data?.Message || error.message);
      }
      navigate(AppRoutesUI.Users.UsersList());
      setFormValue(UserAddDefaultValues);
      setIsLoading(false);
    }
  };

  return (
    <div className="email-card">
      <Form
        formValue={formValue}
        onChange={handleChange}
        model={UserAddFormSchema}
        onSubmit={handleSave}
        fluid
      >
        <UsersEditForm
          isPaid={formValue.userType === "trial" ? false : true}
          userSubscriptionType={userSubscriptionType}
          expiredDateChange={expiredDateChange}
          formValue={formValue}
        />
        <div className="d-flex justify-content-end align-items-center">
          <Button
            size="sm"
            appearance="primary"
            className="m-2 me-3 form-buttons"
            type="submit"
            loading={isLoading}
          >
            Update
          </Button>
        </div>
      </Form>
    </div>
  );
};
